// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__xkj9-","content":"styles_content__3cE2h","selectAll":"styles_selectAll__2QI4x"};